import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserSessionService } from 'bna-angular-auth-client';
import { timeout } from 'rxjs';
import { UserGroupService } from 'src/app/settings/services/user.group.service';

@Component({
  selector: 'app-bookdemo',
  templateUrl: './bookdemo.component.html',
  styleUrls: ['./bookdemo.component.scss'],
})
export class BookdemoComponent implements AfterViewInit {
  userClaims: any;
  constructor(
    public dialogRef: MatDialogRef<BookdemoComponent>,
    private userGroupService: UserGroupService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      agencyName: string;
    }
  ) {}

  ngAfterViewInit(): void {
    this.loadHubSpotScript();
    this.userClaims = this.userGroupService.getProfile();
  }

  loadHubSpotScript(): void {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.renderHubSpotForm();
    };
    document.body.appendChild(script);
  }

  renderHubSpotForm(): void {
    const form = (window as any).hbspt.forms.create({
      region: 'na1',
      portalId: '7315697',
      formId: 'ae6fbdf7-f6bc-40c2-8a15-18c59d8781f4',
      target: '#hubspotFormContainer',
    });

    setTimeout(() => {
      this.autofillHubSpotFormValues(form);
    }, 1000);
  }

  close() {
    this.dialogRef.close();
  }

  autofillHubSpotFormValues(form: any): void {
    const nameParts: string[] = this.userClaims.name.split(' ');

    const fieldValues = {
      firstname: nameParts[0],
      lastname: nameParts[1],
      company: this.data.agencyName,
      email: this.userClaims.email,
      phone: this.userClaims.phoneNumber,
    };
    for (const field in fieldValues) {
      if (fieldValues.hasOwnProperty(field)) {
        form.setFieldValue(field, fieldValues[field]);
      }
    }
  }
}
